/*
* Environment's variables is defined here
* */

export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const ADMIN_PANEL = process.env.REACT_APP_ADMIN_PANEL;
export const PROJECT_TITLE = process.env.REACT_APP_PROJECT_TITLE;